<template>
  <validation-provider
    :rules="rules"
    v-slot="{ errors }"
  >
    <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
      <label class="label" :for="name">
        {{ label }}

        <span v-if="tip" :data-tooltip="tip">
          <ion-icon class="icon" name="help-circle-outline"></ion-icon>
        </span>
      </label>

      <select
        class="form-control"
        :name="name"
        :id="name"
        :value="value"
        :disabled="disabled"
        @change="$emit('input', $event.target.value)"
      >
        <option :value="undefined" v-if="!readonly">Selecione...</option>
        <template v-for="option in options">
          <option
            :value="option.value"
            :key="`${name}-${option.value}`"
            v-if="!readonly || (readonly && option.value === value)"
          >{{ option.label }}</option>
        </template>
      </select>

      <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'SelectField',

  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    options: {
      required: true,
      type: Array,
    },
    tip: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    required: {
      required: false,
      type: Boolean,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rules() {
      if (this.disabled) {
        return '';
      }

      const rules = [];

      if (this.required) {
        rules.push('required');
      }

      return rules.join('|');
    },
  },

  components: {
    ValidationProvider,
  },
};
</script>

<style scoped>

</style>
